import React from 'react';
function Enter({ size, stroke = 'currentColor', ...otherProps }) {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width={size}
      height={size}
      viewBox="0 0 24 24"
      fill="none"
      stroke={stroke}
      {...otherProps}
    >
      <g>
        <path
          d="M16.1666 7.83337V8.56254C16.1666 10.3127 16.1666 11.1878 15.826 11.8563C15.5264 12.4443 15.0483 12.9223 14.4603 13.2219C13.7918 13.5625 12.9167 13.5625 11.1666 13.5625H7.83325M7.83325 13.5625L10.4374 10.9584M7.83325 13.5625L10.4374 16.1667"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
        <path d="M2.65 6C2.65 4.14985 4.14985 2.65 6 2.65H18C19.8502 2.65 21.35 4.14985 21.35 6V18C21.35 19.8502 19.8502 21.35 18 21.35H6C4.14985 21.35 2.65 19.8502 2.65 18V6Z" />
      </g>
    </svg>
  );
}

export default Enter;
